import { useEffect, useState } from 'react';
import DrawerFilterSession from './Drawer/DrawerFilterSession';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import InputBase from '@mui/material/InputBase';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { FilterType } from '../types/enumSessionFilter';
import i18n from '../i18n/i18n';

const SearchRoot = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: '10px',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.mode === 'light' ? '#EBF9FF' : '#3F4C59',
    marginLeft: 0,
    width: '92.5%',
    display: 'flex',
    alignItems: 'center'
}));

const SearchIconWrapper = styled('div')({
    padding: '0 16px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

const StyledInputBase = styled(InputBase)({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
        padding: '8px 8px 8px 0',
        paddingLeft: '0',
        width: '100%',
        '@media (min-width:600px)': {
            width: '12ch',
            '&:focus': { width: '20ch' }
        }
    }
});

type Props = {
    currentFilter: FilterType;
    onFilterChange: (filter: FilterType) => void;
    searchTerm: string;
    onSearchChange: (value: string) => void;
};

const SearchFilterBar = ({ currentFilter, onFilterChange, searchTerm, onSearchChange }: Props) => {
    const [localValue, setLocalValue] = useState(searchTerm);

    useEffect(() => setLocalValue(searchTerm), [searchTerm]);
    useEffect(() => {
        const t = setTimeout(() => onSearchChange(localValue), 160);
        return () => clearTimeout(t);
    }, [localValue, onSearchChange]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '0.25em', mb: '1em' }}>
            <SearchRoot>
                <SearchIconWrapper>
                    <SearchOutlinedIcon />
                </SearchIconWrapper>
                <StyledInputBase placeholder={i18n.t('Search.sessionPlaceholder')} inputProps={{ 'aria-label': 'search' }} value={localValue} onChange={(e) => setLocalValue(e.target.value)} />
                <DrawerFilterSession currentFilter={currentFilter} onFilterChange={onFilterChange} />
            </SearchRoot>
        </Box>
    );
};

export default SearchFilterBar;
